import Timeline from '../../../components/Timeline';
import Component from '../../../components/Component';
import Loading from '../../../components/Loading';

import query from './query';
import keys from './keys';
import { getLabel } from '../../../helpers/date';
import { colors } from '../../../lib/colors';

class GSCReportKeywordDetail extends Component {
    constructor(props) {
        super();
        this.query = query(props.keyword);
    }

    render() {
        if (this.state.loading) {
            return <Loading />;
        }

        const sortedData = this.state.data.sort((a, b) => a.week.localeCompare(b.week));

        const chartData = (datasetIndex) => ({
            labels: sortedData.map((item) => [
                getLabel(item?.start_date?.value),
                getLabel(item?.end_date?.value),
            ]),
            datasets: keys.map((item, i) => ({
                label: item?.label,
                type: 'line',
                data: sortedData.map((data) =>
                    item.render ? item.render(data[item.key]) : data[item.key],
                ),

                backgroundColor: [colors[i], colors[i]],
                borderColor:
                    datasetIndex === null || datasetIndex === i
                        ? colors[i]
                        : 'rgba(128, 128, 128, 0.2)',
                yAxisID: item.yAxisID ?? 'y',
                borderRadius: 4,
                tension: 0.4,
            })),
        });

        const item = (
            <div className="google-trends-btn">
                <a
                    href={`https://trends.google.com/trends/explore?q=${this.props.entity}&date=today 12-m&geo=${this.props.user_geo_location_geo}&hl=en`}
                    target="_blank"
                    rel="noreferrer"
                >
                    <div className="google-trends-btn-img">
                        <img src="/static/img/google-trends.png" loading="lazy" />
                    </div>{' '}
                    View Google Trends Data <i className="icon-arrow-right1" />
                </a>
            </div>
        );

        return (
            <Timeline
                chartSize="lg"
                metricType="primary"
                forceRun={this.forceRun}
                data={this.state.data}
                error={this.state.error}
                keys={keys}
                parent_id={this.props.parent_id}
                content_id={this.props.content_id}
                chartData={chartData}
                xAxisKey="start_date"
                showGoogleFeeds
                hasRightAxis
                extraBox={item}
                rightAxisLabel="CTR (%)"
                rightSecondAxisLabel="Positions"
                hasSecondRightAxis
                hasLeftSecondAxis
                leftSecondAxisLabel="Clicks"
                leftAxisLabel="Impressions"
                secondRightAxisReversed
                chartContainerStyles="d-flex justify-content-between"
            />
        );
    }
}

export default GSCReportKeywordDetail;
